import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";

<template>
  <label class="w-full mb-2 block text-sm font-normal text-gray-700" {{mergeClasses}} ...attributes>
    {{yield}}
  </label>
</template>
